import React from 'react';

import { updatePageloadName } from '@atlaskit/react-ufo/trace-pageload';

/**
 * Updates the UFO event name to
 */
export function ViewPageSplitTinyUFO({ isFabricPage }: { isFabricPage: boolean }) {
	React.useEffect(() => {
		if (!isFabricPage) {
			updatePageloadName('view-page-tiny');
		}
	}, [isFabricPage]);
	return null;
}
